export default class ConnectionSocial {
  constructor() {
    document
      .querySelectorAll('[data-authentication="sso"]')
      .forEach(ConnectionSocial.manageSocialPopup);
  }

  static manageSocialPopup(ssoButton: HTMLLinkElement) {
    ssoButton.addEventListener('click', (e) => {
      e.preventDefault();

      const authPopup = window.open(
        ssoButton.href,
        null,
        'width=600,height=600'
      );

      const interval = setInterval(() => {
        try {
          // The pop-up was closed, probably by the customer
          // Auth should have failed
          if (authPopup.closed) {
            clearInterval(interval);
            return;
          }

          // The pop-up is still on the blank page
          // Auth hasn't started yet
          if (authPopup.location.href === 'about:blank') {
            return;
          }

          // The pop-up is on Eminza, and on the redirect page
          // Auth hasn't started yet
          // Customer will be redirected to the the services' auth page
          if (authPopup.location.href === ssoButton.href) {
            return;
          }

          // The pop-up is no longer on Eminza
          // Auth is in-progress
          if (window.location.host !== authPopup.location.host) {
            return;
          }

          // The pop-up is on Eminza, and on any other page
          // Auth is either successful or failed
          clearInterval(interval);
          authPopup.close();
          window.location.reload();
        } catch (error) {
          // Ignore error
          // Probably "Permission denied to get property "href" on cross-origin object"
          // (Unable to get anything if we're not on the same domain, meaning the auth is still in-pgrogress)
        }
      }, 250);
    });
  }
}
